import { Stack, Typography } from '@mui/joy';
import { PencilSimpleLine, TrashSimple } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';

import { isPromotedSingleChild } from 'core/utils';
import {
  RemoveCorporatePartPriceButton,
  UpsertCorporatePartPriceButton,
} from 'corporate/components/UpsertCorporatePartPrice';
import { CorporatePartCostStatus } from 'corporate/enums';
import { ICorporatePart, ICorporatePartPriceListItem } from 'corporate/types';
import { Color, Direction, Level } from 'theme/enums';

import { IFlatPriceRow } from '../utils';

interface IProps extends ICellRendererParams<IFlatPriceRow> {
  corporatePart: Partial<ICorporatePart>;
}

const iconSx = { cursor: 'pointer' };

const resolveRecord = (
  data: IFlatPriceRow | undefined,
  node: ICellRendererParams['node']
): ICorporatePartPriceListItem | undefined => {
  if (node?.group) {
    return node.allLeafChildren?.[0]?.data?._record;
  }

  return data?._record;
};

export const ActionsCell = ({ corporatePart, data, node }: IProps) => {
  const isGroup = !!node?.group;
  const isPromoted = isPromotedSingleChild({ node });

  if (!isGroup && !isPromoted) {
    return null;
  }

  const record = resolveRecord(data, node);

  const isEditable =
    record?.status === CorporatePartCostStatus.ACTIVE ||
    record?.status === CorporatePartCostStatus.PENDING;

  if (!isEditable || !record) {
    return null;
  }

  return (
    <Stack direction={Direction.ROW} gap={1}>
      <UpsertCorporatePartPriceButton
        corporatePart={corporatePart}
        price={record}
        buttonElement={
          <Typography color={Color.PRIMARY} level={Level.BODY_SM} sx={iconSx}>
            <PencilSimpleLine />
          </Typography>
        }
      />

      <RemoveCorporatePartPriceButton
        prices={[record]}
        buttonElement={
          <Typography color={Color.DANGER} level={Level.BODY_SM} sx={iconSx}>
            <TrashSimple />
          </Typography>
        }
      />
    </Stack>
  );
};
